export default __webpack_public_path__ + "static/media/2021 utensils side.c4eb2010.png";